module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "copyright",
    attrs: {
      "id": "cop"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_vm._v("Originally published by Ace Books, a division of Penguin Putnam, in October 1998."), _c('br'), _vm._v("Published as an ebook by Jabberwocky Literary Agency in June 2011.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("All rights reserved."), _c('br'), _vm._v("Copyright © 1998 by Rick Shelley."), _c('br'), _vm._v("Cover art by Dirk Berger."), _c('br'), _vm._v("This book may not be reproduced in whole or in part, by mimeograph or any other means, without permission.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9bb9c758","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/0441005683_epub_cop_r1.vue
// module id = 66
// module chunks = 0